import classNames from 'classnames';
import { format } from 'date-fns';

import { DeserializedAppData } from '@api';

import NextLink from '@shared/common/components/NextLink';
import { MAGIC_BOOST_SUBMIT_YOUR_PROJECT_URL } from '@shared/constants';
import { APP_STATUS, AppStatusValue } from '@shared/helpers/app';

interface AppDetailsStatusBannerProps {
  app: DeserializedAppData;
  appStatus: Exclude<AppStatusValue, typeof APP_STATUS.VALIDATED>;
  className?: string;
}

const AppDetailsStatusBanner = ({ app, appStatus, className }: AppDetailsStatusBannerProps) => {
  const { upcomingDate, appLink } = app.attributes;
  const isReadOnly = appStatus === APP_STATUS.READ_ONLY;

  return (
    <div
      className={classNames(
        'min-h-[3.125rem] px-4 py-2.5 flex justify-center items-center',
        {
          [APP_STATUS.UPCOMING]: 'bg-primary-100',
          [APP_STATUS.READ_ONLY]: 'bg-primary-100',
          [APP_STATUS.UNDER_VALIDATION]: 'bg-orange-100',
          [APP_STATUS.UNVALIDATED]: 'bg-red-300',
        }[appStatus],
        className,
      )}
    >
      <p className="text-xs text-center" data-qa="upcoming-banner">
        {appStatus === APP_STATUS.UPCOMING && (
          <>
            Apps in the Upcoming Section are not Live or Validated -{' '}
            <span className="font-bold">
              {' '}
              Launch Estimated:{' '}
              {upcomingDate ? format(new Date(upcomingDate), 'MMM do, y') : ' TBD'}
            </span>
          </>
        )}

        {appStatus === APP_STATUS.UNDER_VALIDATION && (
          <>
            This App is undergoing its Validation Process. To participate in the Vote,{' '}
            <NextLink
              href={`/app/${appLink}/validation`}
              className="text-secondary-700 font-bold"
              data-qa="info-under-validation-link"
            >
              Click&nbsp;Here&gt;&gt;
            </NextLink>
          </>
        )}

        {isReadOnly && (
          <>
            This project is for preview only and has not been validated by our community. If you are
            the owner and wish to get validated, please{' '}
            <NextLink
              href={MAGIC_BOOST_SUBMIT_YOUR_PROJECT_URL}
              className="text-primary-700"
              data-qa="info-read-only-link"
            >
              submit&nbsp;an&nbsp;application.
            </NextLink>
          </>
        )}

        {appStatus === APP_STATUS.UNVALIDATED && <>Validation failed</>}
      </p>
    </div>
  );
};

export default AppDetailsStatusBanner;
